// extracted by mini-css-extract-plugin
export default {"overflow-label":"overflow-header_overflow-label__UVxni"};